import { just, nothing, type Maybe } from "./maybe";

/**
 * Wire/DOM string edge helper for #241.
 * Trim; missing/blank → Nothing. Prefer this over peeling to null in app code.
 */
export function trimmedMaybe(value: string | null | undefined): Maybe<string> {
  if (value === null || value === undefined) return nothing;
  const trimmed = value.trim();
  return trimmed.length > 0 ? just(trimmed) : nothing;
}

/**
 * Wire-out helper when an API still wants `string | null`.
 * Prefer `trimmedMaybe` in app/Pinia/Vue code.
 */
export function trimmedOrNull(value: string | null | undefined): string | null {
  const m = trimmedMaybe(value);
  return m.tag === "just" ? m.value : null;
}

/** Like trimmedMaybe but blank → empty string (not Nothing). */
export function trimmedOrEmpty(value: string | null | undefined): string {
  if (value === null || value === undefined) return "";
  return value.trim();
}
